import {
  defaultCreatorGrants,
  type GrantEntry,
  type RoleOption,
} from "../../shared/rbac/roles";
import {
  roleDefaultsForSpace,
  type SpaceGrant,
  type SpacePrincipalRoles,
  strongestSpaceGrants,
} from "./spaceSupplierGrants";

// Builds the skill grants a space's members should hold so the space can use the
// skill: anyone who can see the space gets read access (skill_user), while the
// creator gets full access (manage + use). The space_uses_skills rule requires
// only skill:read for every space role, so a single read grant covers all members.
export function skillGrantsForSpace(
  spaceGrants: readonly SpaceGrant[],
  currentUserId?: string
): GrantEntry[] {
  const grants: GrantEntry[] = [];
  for (const { principal } of strongestSpaceGrants(
    spaceGrants,
    "space_uses_skills"
  )) {
    // The creator gets full access below, so skip their read-only grant here.
    if (
      currentUserId &&
      "userId" in principal &&
      principal.userId === currentUserId
    )
      continue;
    grants.push({ ...principal, builtinRoleId: "skill_user" });
  }
  if (currentUserId)
    grants.push(...defaultCreatorGrants("skill", { userId: currentUserId }));
  return grants;
}

// Maps a space's skill grants to the RoleOptions each principal should be
// pre-staged with when the space is added to a skill.
export function skillRoleDefaultsForSpace(
  spaceGrants: readonly SpaceGrant[],
  roleOptions: readonly RoleOption[]
): SpacePrincipalRoles {
  return roleDefaultsForSpace(skillGrantsForSpace(spaceGrants), roleOptions);
}
